import { useState } from 'react';
import { Helmet } from 'react-helmet';
import { 
  FaHome,
  FaSearch,
  FaMapMarkerAlt,
  FaBus,
  FaUsers,
  FaMapMarkedAlt,
  FaPhone,
  FaClock,
  FaShieldAlt,
  FaUserTie,
  FaFemale,

  FaCheckCircle,
  FaRupeeSign,
  FaInfoCircle,
  FaExclamationTriangle,
  FaMoneyBillWave,
  FaMedkit,
  FaFireExtinguisher,
  FaWrench,
  FaMap,
} from 'react-icons/fa';
import { title as siteTitle } from '../constants/constant';
import Layout from '../components/layout/Layout';
import BreadcrumbImg from '../assets/images/breadcrumb.png';
import { headerData } from '../data/headerData';

// Constants Data
const breadcrumbData = {
  home: { text: "Home", path: "/" },
  current: "Transport",
  title: "Transport Routes",
  image: BreadcrumbImg
};

const statsData = [
  { id: 1, icon: FaBus, value: "5", label: "Active Routes", color: "text-blue-600", bgColor: "bg-blue-50" },
  { id: 2, icon: FaUsers, value: "180+", label: "Students", color: "text-emerald-600", bgColor: "bg-emerald-50" },
  { id: 3, icon: FaMap, value: "GPS", label: "Live Tracking", color: "text-purple-600", bgColor: "bg-purple-50" },
  { id: 4, icon: FaShieldAlt, value: "100%", label: "Safety Record", color: "text-amber-600", bgColor: "bg-amber-50" }
];

const zones = [
  { id: "all", name: "All Areas", count: 5, icon: FaMapMarkerAlt },
  { id: "central", name: "Central Zone", count: 1, icon: FaMapMarkerAlt },
  { id: "north", name: "North Zone", count: 1, icon: FaMapMarkerAlt },
  { id: "south", name: "South Zone", count: 1, icon: FaMapMarkerAlt },
  { id: "east", name: "East Zone", count: 1, icon: FaMapMarkerAlt },
  { id: "west", name: "West Zone", count: 1, icon: FaMapMarkerAlt }
];

const featuresData = [
  { id: 1, icon: FaFemale, title: "Trained Staff", description: "Female attendants in each bus", color: "text-blue-600" },
  { id: 2, icon: FaMap, title: "GPS Tracking", description: "Real-time bus location", color: "text-blue-600" },
  { id: 3, icon: FaPhone, title: "Emergency Contact", description: "24/7 transport helpline", color: "text-blue-600" },
  { id: 4, icon: FaMoneyBillWave, title: "Flexible Payment", description: "Monthly/Quarterly options", color: "text-blue-600" }
];

const routesData = [
  {
    id: 1,
    name: "Route 1 - City Center",
    zone: "central",
    color: "bg-blue-600",
    active: true,
    driver: {
      name: "Mr. Rajesh Kumar",
      phone: "+91 98765 43210"
    },
    capacity: 40,
    busNumber: "UP-65-1234",
    stops: [
      { id: 1, name: "Main Bus Stand", location: "Opposite Railway Station", time: "7:00 AM" },
      { id: 2, name: "Gandhi Chowk", location: "Near Central Bank", time: "7:15 AM" },
      { id: 3, name: "City Mall", location: "Main Entrance", time: "7:30 AM" },
      { id: 4, name: "Medical College", location: "Gate No. 2", time: "7:45 AM" },
      { id: 5, name: "School Arrival", location: "Main Gate", time: "8:00 AM" }
    ],
    returnStops: [
      { id: 1, name: "School Departure", time: "2:45 PM" },
      { id: 2, name: "Medical College", time: "3:00 PM" },
      { id: 3, name: "City Mall", time: "3:15 PM" },
      { id: 4, name: "Gandhi Chowk", time: "3:30 PM" },
      { id: 5, name: "Main Bus Stand", time: "3:45 PM" }
    ]
  },
  {
    id: 2,
    name: "Route 2 - North Zone",
    zone: "north",
    color: "bg-emerald-600",
    active: true,
    driver: {
      name: "Mr. Sanjay Verma",
      phone: "+91 98765 43211"
    },
    capacity: 35,
    busNumber: "UP-65-5678",
    stops: [
      { id: 1, name: "North Market", location: "Bus Stand", time: "7:00 AM" },
      { id: 2, name: "Sector 5", location: "Park Entrance", time: "7:20 AM" },
      { id: 3, name: "Apna Bazar", location: "Supermarket", time: "7:35 AM" },
      { id: 4, name: "Gurudwara Road", location: "Crossing", time: "7:50 AM" },
      { id: 5, name: "School Arrival", location: "Main Gate", time: "8:10 AM" }
    ],
    returnStops: [
      { id: 1, name: "School Departure", time: "2:45 PM" },
      { id: 2, name: "Gurudwara Road", time: "3:00 PM" },
      { id: 3, name: "Apna Bazar", time: "3:15 PM" },
      { id: 4, name: "Sector 5", time: "3:30 PM" },
      { id: 5, name: "North Market", time: "3:50 PM" }
    ]
  },
  {
    id: 3,
    name: "Route 3 - South Zone",
    zone: "south",
    color: "bg-purple-600",
    active: true,
    driver: {
      name: "Ms. Priya Sharma",
      phone: "+91 98765 43212"
    },
    capacity: 38,
    busNumber: "UP-65-9101",
    stops: [
      { id: 1, name: "South Extension", location: "Market Square", time: "6:45 AM" },
      { id: 2, name: "Green Park", location: "Community Center", time: "7:05 AM" },
      { id: 3, name: "Model Town", location: "Roundabout", time: "7:25 AM" },
      { id: 4, name: "Industrial Area", location: "Gate No. 1", time: "7:45 AM" },
      { id: 5, name: "School Arrival", location: "Main Gate", time: "8:05 AM" }
    ],
    returnStops: [
      { id: 1, name: "School Departure", time: "2:45 PM" },
      { id: 2, name: "Industrial Area", time: "3:05 PM" },
      { id: 3, name: "Model Town", time: "3:25 PM" },
      { id: 4, name: "Green Park", time: "3:45 PM" },
      { id: 5, name: "South Extension", time: "4:05 PM" }
    ]
  },
  {
    id: 4,
    name: "Route 4 - East Zone",
    zone: "east",
    color: "bg-amber-600",
    active: true,
    driver: {
      name: "Mr. Amit Patel",
      phone: "+91 98765 43213"
    },
    capacity: 32,
    busNumber: "UP-65-1122",
    stops: [
      { id: 1, name: "East Gate", location: "Municipal Office", time: "7:15 AM" },
      { id: 2, name: "River View", location: "Bridge Point", time: "7:35 AM" },
      { id: 3, name: "Old City", location: "Temple Entrance", time: "7:55 AM" },
      { id: 4, name: "School Arrival", location: "Main Gate", time: "8:10 AM" }
    ],
    returnStops: [
      { id: 1, name: "School Departure", time: "2:45 PM" },
      { id: 2, name: "Old City", time: "3:00 PM" },
      { id: 3, name: "River View", time: "3:20 PM" },
      { id: 4, name: "East Gate", time: "3:40 PM" }
    ]
  },
  {
    id: 5,
    name: "Route 5 - West Zone",
    zone: "west",
    color: "bg-rose-600",
    active: true,
    driver: {
      name: "Mr. Ramesh Singh",
      phone: "+91 98765 43214"
    },
    capacity: 42,
    busNumber: "UP-65-3344",
    stops: [
      { id: 1, name: "West End", location: "Bus Depot", time: "6:30 AM" },
      { id: 2, name: "University Road", location: "Main Gate", time: "6:50 AM" },
      { id: 3, name: "Sports Complex", location: "Stadium Entrance", time: "7:10 AM" },
      { id: 4, name: "Tech Park", location: "Building A", time: "7:30 AM" },
      { id: 5, name: "School Arrival", location: "Main Gate", time: "7:50 AM" }
    ],
    returnStops: [
      { id: 1, name: "School Departure", time: "2:45 PM" },
      { id: 2, name: "Tech Park", time: "3:05 PM" },
      { id: 3, name: "Sports Complex", time: "3:25 PM" },
      { id: 4, name: "University Road", time: "3:45 PM" },
      { id: 5, name: "West End", time: "4:05 PM" }
    ]
  }
];

const safetyMeasures = [
  { text: "First aid kit in every bus", icon: FaMedkit },
  { text: "Speed governors installed", icon: FaWrench },
  { text: "Regular vehicle maintenance", icon: FaWrench },
  { text: "Fire extinguishers available", icon: FaFireExtinguisher },
  { text: "Emergency exits marked", icon: FaExclamationTriangle },
  { text: "Seat belts for all seats", icon: FaShieldAlt }
];

const feeData = [
  { period: "Monthly Fee", amount: "₹ 1,500" },
  { period: "Quarterly Fee", amount: "₹ 4,200" },
  { period: "Annual Fee", amount: "₹ 15,000" }
];

const officeData = {
  incharge: "Mr. Ravi Shankar",
  phones: ["+91 98765 43210", "+91 98765 43211"],
  hours: [
    "Monday - Friday: 8:00 AM - 4:00 PM",
    "Saturday: 8:00 AM - 1:00 PM"
  ]
};

const importantNotes = [
  "Students must be at the stop 5 minutes before scheduled time",
  "Parents must inform transport office about changes in pickup/drop",
  "Route changes may occur due to road conditions or events",
  "Fees are non-refundable for partial month usage"
];

export default function TransportRoutes() {
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedZone, setSelectedZone] = useState("all");

  const filteredRoutes = routesData.filter(route => {
    const matchesZone = selectedZone === "all" || route.zone === selectedZone;
    const matchesSearch = route.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
                         route.stops.some(stop => stop.name.toLowerCase().includes(searchQuery.toLowerCase()));
    return matchesZone && (searchQuery === "" || matchesSearch);
  });

  return (
    <Layout>
      <Helmet>
        <title>Transport Routes | {siteTitle}</title>
        <meta name="description" content="View school transport routes, bus schedules, pickup points, and safety measures at Gyan Rashmi." />
      </Helmet>

      {/* Breadcrumb Section */}
      <div className="relative bg-gray-900">
        <div className="h-40 md:h-48">
          <img 
            alt="Breadcrumb" 
            className="object-cover w-full h-full opacity-60" 
            src={breadcrumbData.image} 
          />
          <div className="absolute inset-0 bg-black/50"></div>
        </div>
        <div className="absolute inset-0 flex flex-col items-center justify-center text-center">
          <div className="flex items-center mb-2 text-sm text-white">
            <a 
              href={breadcrumbData.home.path} 
              className="flex items-center transition-colors hover:text-gray-200"
            >
              <FaHome className="w-3 h-3 mr-1.5" />
              {breadcrumbData.home.text}
            </a>
            <span className="mx-2">/</span>
            <span className="font-semibold">{breadcrumbData.current}</span>
          </div>
          <h1 className="text-2xl font-bold text-white md:text-3xl">{breadcrumbData.title}</h1>
        </div>
      </div>

      {/* Main Content */}
      <div className="container px-3 py-5 mx-auto max-w-7xl md:px-4 md:py-6">
        {/* Stats Cards */}
        <div className="grid grid-cols-2 gap-3 mb-5 md:grid-cols-4">
          {statsData.map((stat) => (
            <div key={stat.id} className="p-3 text-center bg-white border border-gray-200 rounded-xl">
              <stat.icon className={`w-5 h-5 mx-auto mb-1 ${stat.color}`} />
              <div className="text-base font-bold text-gray-900 md:text-lg">{stat.value}</div>
              <div className="text-xs text-gray-600">{stat.label}</div>
            </div>
          ))}
        </div>

        {/* Search and Filter Bar */}
        <div className="p-3 mb-5 bg-white border border-gray-200 rounded-xl">
          <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
            {/* Search */}
            <div className="relative flex-1">
              <FaSearch className="absolute w-3.5 h-3.5 text-gray-400 transform -translate-y-1/2 left-3 top-1/2" />
              <input 
                placeholder="Search routes or stops..." 
                className="w-full py-1.5 pl-8 pr-3 text-xs border border-gray-300 rounded-lg focus:ring-1 focus:ring-blue-500 focus:border-transparent"
                type="text"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </div>

            {/* Zone Filters */}
            <div className="flex flex-wrap gap-1.5">
              {zones.map((zone) => (
                <button
                  key={zone.id}
                  onClick={() => setSelectedZone(zone.id)}
                  className={`flex items-center gap-1.5 px-2.5 py-1.5 text-xs font-medium rounded-lg transition-colors ${
                    selectedZone === zone.id
                      ? 'bg-blue-600 text-white'
                      : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                  }`}
                >
                  <zone.icon className="w-3 h-3" />
                  {zone.name}
                  <span className={`px-1 py-0.5 text-[10px] rounded-full ${
                    selectedZone === zone.id ? 'bg-white/20' : 'bg-gray-200'
                  }`}>
                    {zone.count}
                  </span>
                </button>
              ))}
            </div>
          </div>
        </div>

        {/* Transport Features */}
        <div className="mb-6">
          <h3 className="mb-3 text-sm font-bold text-center text-gray-900">Transport Features</h3>
          <div className="grid grid-cols-2 gap-3 md:grid-cols-4">
            {featuresData.map((feature) => (
              <div key={feature.id} className="p-3 text-center transition-shadow bg-white border border-gray-200 rounded-xl hover:shadow-sm">
                <div className="inline-flex items-center justify-center w-8 h-8 mb-2 rounded-full bg-blue-50">
                  <feature.icon className={`w-4 h-4 ${feature.color}`} />
                </div>
                <div className="mb-0.5 text-xs font-bold text-gray-900">{feature.title}</div>
                <div className="text-[10px] text-gray-600">{feature.description}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Routes List */}
        <div className="grid gap-4 mb-6">
          {filteredRoutes.map((route) => (
            <div key={route.id} className="overflow-hidden transition-shadow bg-white border border-gray-200 rounded-xl hover:shadow-md">
              {/* Route Header */}
              <div className="p-4 border-b border-gray-200">
                <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
                  <div className="flex items-center gap-3">
                    <div className={`w-10 h-10 rounded-lg ${route.color} flex items-center justify-center flex-shrink-0`}>
                      <FaBus className="w-5 h-5 text-white" />
                    </div>
                    <div>
                      <div className="flex items-center gap-2 mb-1">
                        <h3 className="text-sm font-bold text-gray-900">{route.name}</h3>
                        <span className="px-1.5 py-0.5 text-[10px] font-medium rounded-full bg-green-100 text-green-700">
                          active
                        </span>
                      </div>
                      <div className="flex flex-wrap gap-2 text-xs text-gray-600">
                        <div className="flex items-center gap-1">
                          <FaUserTie className="w-3 h-3" />
                          <span>{route.driver.name}</span>
                        </div>
                        <div className="flex items-center gap-1">
                          <FaUsers className="w-3 h-3" />
                          <span>Capacity: {route.capacity} Students</span>
                        </div>
                        <div className="flex items-center gap-1">
                          <FaPhone className="w-3 h-3" />
                          <span>{route.driver.phone}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="flex gap-2">
                    <button className="px-3 py-1.5 text-xs text-white bg-blue-600 rounded-lg hover:bg-blue-700">
                      View Details
                    </button>
                    <button className="px-3 py-1.5 text-xs text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50">
                      Track Bus
                    </button>
                  </div>
                </div>
              </div>

              {/* Route Stops */}
              <div className="p-4">
                <div className="grid gap-4 md:grid-cols-2">
                  {/* Morning Pickup */}
                  <div>
                    <div className="flex items-center gap-1.5 mb-2">
                      <FaClock className="w-3.5 h-3.5 text-blue-600" />
                      <h4 className="text-xs font-bold text-gray-900">Morning Pickup (To School)</h4>
                    </div>
                    <div className="space-y-2">
                      {route.stops.map((stop) => (
                        <div key={stop.id} className="flex items-start gap-2">
                          <div className="flex-shrink-0">
                            <div className="flex items-center justify-center w-5 h-5 bg-blue-100 rounded-full">
                              <span className="text-[8px] font-bold text-blue-700">{stop.id}</span>
                            </div>
                          </div>
                          <div className="flex-1">
                            <div className="flex items-center justify-between">
                              <div className="text-xs font-medium text-gray-900">{stop.name}</div>
                              <div className="text-[10px] font-medium text-blue-600">{stop.time}</div>
                            </div>
                            {stop.location && (
                              <div className="flex items-center gap-1 text-[10px] text-gray-600">
                                <FaMapMarkerAlt className="w-2.5 h-2.5" />
                                <span>{stop.location}</span>
                              </div>
                            )}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* Evening Drop */}
                  <div>
                    <div className="flex items-center gap-1.5 mb-2">
                      <FaClock className="w-3.5 h-3.5 text-emerald-600" />
                      <h4 className="text-xs font-bold text-gray-900">Evening Drop (From School)</h4>
                    </div>
                    <div className="space-y-2">
                      {route.returnStops.map((stop) => (
                        <div key={stop.id} className="flex items-start gap-2">
                          <div className="flex-shrink-0">
                            <div className="flex items-center justify-center w-5 h-5 rounded-full bg-emerald-100">
                              <span className="text-[8px] font-bold text-emerald-700">{stop.id}</span>
                            </div>
                          </div>
                          <div className="flex-1">
                            <div className="flex items-center justify-between">
                              <div className="text-xs font-medium text-gray-900">{stop.name}</div>
                              <div className="text-[10px] font-medium text-emerald-600">{stop.time}</div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>

                {/* Route Map Link */}
                <div className="p-3 mt-4 border border-gray-200 rounded-lg bg-gray-50">
                  <div className="flex items-center gap-1.5 mb-1.5">
                    <FaMapMarkedAlt className="w-3.5 h-3.5 text-purple-600" />
                    <h5 className="text-xs font-bold text-gray-900">Route Map</h5>
                  </div>
                  <div className="flex items-center justify-between text-xs">
                    <div className="text-gray-600">{route.stops.length} stops • {route.returnStops.length} return stops</div>
                    <button className="flex items-center gap-1 font-medium text-blue-600 hover:text-blue-700">
                      <FaMapMarkedAlt className="w-3 h-3" />
                      View Full Map
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Safety Measures */}
        <div className="p-4 mb-5 border border-blue-200 bg-gradient-to-r from-blue-50 to-cyan-50 rounded-xl">
          <div className="flex items-center gap-2 mb-3">
            <FaShieldAlt className="w-4 h-4 text-blue-600" />
            <h3 className="text-sm font-bold text-gray-900">Safety Measures</h3>
          </div>
          <div className="grid gap-2 md:grid-cols-2 lg:grid-cols-3">
            {safetyMeasures.map((item, idx) => (
              <div key={idx} className="flex items-center gap-2 p-2 bg-white border border-blue-100 rounded-lg">
                <FaCheckCircle className="w-3.5 h-3.5 text-green-500 flex-shrink-0" />
                <span className="text-xs text-gray-700">{item.text}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Transport Fee and Office */}
        <div className="grid gap-4 mb-5 md:grid-cols-2">
          {/* Transport Fee */}
          <div className="p-4 bg-white border border-gray-200 rounded-xl">
            <div className="flex items-center gap-2 mb-3">
              <FaRupeeSign className="w-4 h-4 text-emerald-600" />
              <h3 className="text-sm font-bold text-gray-900">Transport Fee</h3>
            </div>
            <div className="space-y-2">
              {feeData.map((item, idx) => (
                <div key={idx} className="flex items-center justify-between p-2 text-xs rounded-lg bg-gray-50">
                  <span className="text-gray-700">{item.period}</span>
                  <span className="font-bold text-emerald-600">{item.amount}</span>
                </div>
              ))}
              <div className="p-2 text-xs rounded-lg bg-blue-50">
                <p className="text-blue-700">* Fees include GPS tracking and female attendant services</p>
              </div>
            </div>
          </div>

          {/* Transport Office */}
          <div className="p-4 border border-purple-200 bg-gradient-to-br from-purple-50 to-pink-50 rounded-xl">
            <div className="flex items-center gap-2 mb-3">
              <FaPhone className="w-4 h-4 text-purple-600" />
              <h3 className="text-sm font-bold text-gray-900">Transport Office</h3>
            </div>
            <div className="space-y-3">
              <div>
                <div className="mb-0.5 text-[10px] text-gray-600">Transport Incharge</div>
                <div className="text-xs font-bold text-gray-900">{officeData.incharge}</div>
              </div>
              <div>
                <div className="mb-0.5 text-[10px] text-gray-600">Contact Numbers</div>
                <div className="space-y-0.5">
                  {officeData.phones.map((phone, idx) => (
                    <div key={idx} className="text-xs font-medium text-gray-900">{phone}</div>
                  ))}
                </div>
              </div>
              <div>
                <div className="mb-0.5 text-[10px] text-gray-600">Office Hours</div>
                <div className="space-y-0.5">
                  {officeData.hours.map((hour, idx) => (
                    <p key={idx} className="text-[10px] text-gray-700">{hour}</p>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Important Notes */}
        <div className="p-4 mb-5 border bg-gradient-to-r from-amber-50 to-orange-50 border-amber-200 rounded-xl">
          <div className="flex items-center gap-2 mb-3">
            <FaInfoCircle className="w-4 h-4 text-amber-600" />
            <h3 className="text-sm font-bold text-gray-900">Important Notes</h3>
          </div>
          <div className="space-y-1.5">
            {importantNotes.map((note, idx) => (
              <div key={idx} className="flex items-start gap-1.5">
                <div className="w-1 h-1 mt-1.5 bg-amber-500 rounded-full flex-shrink-0"></div>
                <p className="text-xs text-gray-700">{note}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Call to Action */}
        <div className="p-5 text-center text-white bg-gradient-to-r from-blue-600 to-cyan-600 rounded-xl">
          <h3 className="mb-2 text-base font-bold">Need Transport Service?</h3>
          <p className="max-w-2xl mx-auto mb-4 text-xs text-blue-100">
            Register for school transport service by visiting the transport office or filling the online form
          </p>
          <div className="flex flex-wrap justify-center gap-2">
            <button className="px-4 py-2 text-xs font-bold text-blue-700 bg-white rounded-lg hover:bg-blue-50">
              Register Now
            </button>
            <button className="px-4 py-2 text-xs font-bold text-white bg-transparent border border-white rounded-lg hover:bg-white/10">
              Download Form
            </button>
          </div>
        </div>
      </div>
    </Layout>
  );
}